import { useSnackbar } from 'notistack';
import { useEffect } from 'react';

interface UpdateCheckerProps {

}

interface ManifestVersion {
    version?: string;
}

function NewVersionMessage() {
    return (
        <span style={{ cursor: 'pointer' }}>
            Existe uma nova versão do sistema
            <br />
            Clique aqui para atualizar
        </span>
    );
}

interface VersionInfoProps {
    version: string;
}

function VersionInfo({ version }: VersionInfoProps) {
    return (
        <div style={{
            position: 'absolute',
            right: 0, bottom: 0,
            padding: 4,
            fontSize: 12
        }}>
            {version}
        </div>
    );
}

export default function UpdateChecker(props: UpdateCheckerProps) {

    const { enqueueSnackbar } = useSnackbar();

    var timer: number = 0;

    useEffect(() => {
        startTimer();
        checkForUpdate(true);
        return stopTimer;
    }, []);

    function startTimer() {
        timer = window.setInterval(checkForUpdate, 300 * 1000);///5 minutes        
    }

    function stopTimer() {
        window.clearInterval(timer);
    }

    async function checkForUpdate(now: boolean = false) {
        try {
            const response = await fetch('manifest.json?q=' + Date.now());
            if (response.ok === false) return;
            const { version } = await response.json() as ManifestVersion;
            const lastModified = response.headers.get('last-modified');
            const storedLastModified = localStorage.getItem('last-modified');
            if (lastModified) {
                if (storedLastModified == null) {
                    localStorage.setItem('last-modified', lastModified);
                    localStorage.setItem('appVersion', version || '');
                } else if (storedLastModified !== lastModified) {
                    if (now) {
                        localStorage.setItem('last-modified', lastModified);
                        localStorage.setItem('appVersion', version || '');
                        window.location.reload();
                    } else {
                        stopTimer();
                        enqueueSnackbar(<NewVersionMessage />, {
                            variant: 'info',
                            onClick: () => {
                                localStorage.setItem('last-modified', lastModified);
                                localStorage.setItem('appVersion', version || '');
                                window.location.reload();
                            },
                            title: 'Nova versão do sistema',
                            persist: true
                        });
                    }
                }
            }
        } catch (e) {
            console.error('checkForUpdate', e);
        }
    }

    return null;
}